/**
 * Token 工具 - Bearer 格式转换
 */

/** 转为 Authorization 头格式（Bearer xxx） */
export function toBearerHeader(raw: string | null): string {
  const t = (raw ?? '').trim();
  if (!t) return '';
  return t.startsWith('Bearer ') ? t : `Bearer ${t}`;
}

/** 提取裸 token（去掉 Bearer 前缀，供 socket auth 等用） */
export function extractToken(raw: string | null): string {
  const t = (raw ?? '').trim();
  if (!t) return '';
  return t.startsWith('Bearer ') ? t.slice('Bearer '.length) : t;
}
